import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { EmployeeSkillConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { EmployeeSkillService } from './api/employeeSkill.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class EmployeeSkillApiModule {
    public static forRoot(configurationFactory: () => EmployeeSkillConfiguration): ModuleWithProviders<EmployeeSkillApiModule> {
        return {
            ngModule: EmployeeSkillApiModule,
            providers: [ { provide: EmployeeSkillConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: EmployeeSkillApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('EmployeeSkillApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
